// extracted by mini-css-extract-plugin
export default {"costCell":"VoxRoiConfigEditor_costCell__tNnBB"};